/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { forwardRef } from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules, getTestId } from '@utils';

import { InputKeys } from '../../types';

import style from './Input.scss';

const cn = bemCssModules(style, 'Input');
const ti = getTestId('Input');

export type TInput = {
  className?: string;
  name: InputKeys;
  label?: string;
  value?: string;
  isActive: boolean;
  disabled?: boolean;
  onChange(event: React.ChangeEvent<HTMLInputElement>): void;
  onFocus(name: InputKeys): void;
  onBlur(): void;
  testId?: string;
};

const Input = forwardRef<HTMLLabelElement, TInput>((props, ref) => {
  const {
    className,
    name,
    label,
    value = '',
    disabled,
    onChange,
    onFocus,
    onBlur,
    isActive,
    testId,
  } = props;

  const { t } = useTranslation();

  const handleFocus = () => onFocus(name);

  return (
    <label ref={ref} className={cn(null, [className])} data-testid={ti(testId)}>
      <small className={cn('label', { focus: isActive })}>{label}</small>
      <input
        className={cn('input', ['h2'])}
        type="text"
        value={value}
        onChange={onChange}
        placeholder={value || t('payments_input.select')}
        onFocus={handleFocus}
        onBlur={onBlur}
        disabled={disabled}
      />
    </label>
  );
});

export default Input;
